import { createFileRoute } from '@tanstack/react-router'
import { LogisticsPage } from '~/components/routes/logistics/logistics-page'
import { LogisticsRouteGuard } from '~/components/routes/logistics/logistics-route-guard'
import { withRoutePermissions } from '~/utils/rbac'
import { LOGISTICS_READ } from '~/components/routes/logistics/tabs'
import { logisticsSearchSchema } from './-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/')({
  staticData: {
    permission: LOGISTICS_READ,
  },
  component: LogisticsRoute,
  validateSearch: logisticsSearchSchema,
})

withRoutePermissions(Route)

function LogisticsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <LogisticsRouteGuard permission={LOGISTICS_READ}>
      <LogisticsPage search={search} navigate={navigate} />
    </LogisticsRouteGuard>
  )
}
